(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .factory('renewLegendModal', renewLegendModal);

    renewLegendModal.$inject = ['$uibModal'];
    function renewLegendModal($uibModal) {
        return function renewLegendModal() {
            return $uibModal.open({ component: 'sc3RenewLegendModal', size: 'lg' });
        }
    }
})();